import { render, staticRenderFns } from "./WidgetsSettings.vue?vue&type=template&id=55153c73&"
import script from "./WidgetsSettings.vue?vue&type=script&lang=js&"
export * from "./WidgetsSettings.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsSettings.vue?vue&type=style&index=0&id=55153c73&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports